export const FETCH_TICKET_DEPENDANTS_INCORPORATIONS =
  'FETCH_TICKET_DEPENDANTS_INCORPORATIONS';
export const SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING =
  'SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING';
export const SET_TICKET_DEPENDANTS_INCORPORATIONS =
  'SET_TICKET_DEPENDANTS_INCORPORATIONS';
export const GET_TICKET_DEPENDANTS_INCORPORATIONS =
  'GET_TICKET_DEPENDANTS_INCORPORATIONS';
export const DELETE_TICKET_DEPENDANT_INCORPORATION =
  'DELETE_TICKET_DEPENDANT_INCORPORATION';
export const FETCH_TICKET_AVAILABLE_COVERAGES =
  'FETCH_TICKET_AVAILABLE_COVERAGES';
export const FETCH_TICKET_AVAILABLE_COVERAGE_INCORPORATIONS =
  'FETCH_TICKET_AVAILABLE_COVERAGE_INCORPORATIONS';
export const SET_TICKET_AVAILABLE_COVERAGES = 'SET_TICKET_AVAILABLE_COVERAGES';
export const GET_TICKET_AVAILABLE_COVERAGES = 'GET_TICKET_AVAILABLE_COVERAGES';

export const FETCH_TICKET_DEPENDENT_INCORPORATIONS =
  'FETCH_TICKET_DEPENDENT_INCORPORATIONS';
export const POST_TICKET_DEPENDENT_INCORPORATION =
  'POST_TICKET_DEPENDENT_INCORPORATION';
export const PATCH_TICKET_DEPENDENT_INCORPORATION =
  'PATCH_TICKET_DEPENDENT_INCORPORATION';
export const DELETE_TICKET_DEPENDENT_INCORPORATION =
  'DELETE_TICKET_DEPENDENT_INCORPORATION';
export const FETCH_TICKET_DEPENDENT_INCORPORATION_COVERAGES =
  'FETCH_TICKET_DEPENDENT_INCORPORATION_COVERAGES';
export const PUT_TICKET_DEPENDENT_INCORPORATION_COVERAGES =
  'PUT_TICKET_DEPENDENT_INCORPORATION_COVERAGES';
export const PATCH_TICKET_STATUS = 'PATCH_TICKET_STATUS';
